import {
  BriefcaseMedical,
  Clock3,
  FileText,
  FolderOpen,
  Heart,
  Home,
  LayoutDashboard,
  LogOut,
  Mail,
  Menu,
  Settings,
  ShieldCheck,
  UserCircle2,
  X,
} from "lucide-react";

import {
  useEffect,
  useState,
} from "react";

import {
  NavLink,
  Outlet,
  useNavigate,
} from "react-router-dom";

import "./ProfessionalLayout.css";

function ProfessionalLayout() {
  const navigate =
    useNavigate();

  const [
    sidebarOpen,
    setSidebarOpen,
  ] = useState(false);

  const [
    user,
    setUser,
  ] = useState(null);

  useEffect(() => {
    try {
      const storedUser =
        localStorage.getItem(
          "zethUser"
        ) ||
        sessionStorage.getItem(
          "zethUser"
        );

      const token =
        localStorage.getItem(
          "zethAuthToken"
        ) ||
        sessionStorage.getItem(
          "zethAuthToken"
        );

      if (
        !storedUser ||
        !token
      ) {
        navigate(
          "/professional/login",
          {
            replace: true,
          }
        );

        return;
      }

      const parsedUser =
        JSON.parse(
          storedUser
        );

      if (
        parsedUser?.role !==
        "professional"
      ) {
        navigate(
          "/professional/login",
          {
            replace: true,
          }
        );

        return;
      }

      setUser(
        parsedUser
      );
    } catch (error) {
      console.error(
        "Professional layout auth error:",
        error
      );

      navigate(
        "/professional/login",
        {
          replace: true,
        }
      );
    }
  }, [
    navigate,
  ]);

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem(
      "zethAuthToken"
    );

    localStorage.removeItem(
      "zethUser"
    );

    sessionStorage.removeItem(
      "zethAuthToken"
    );

    sessionStorage.removeItem(
      "zethUser"
    );

    navigate(
      "/professional/login",
      {
        replace: true,
      }
    );
  };

  const navItems = [
    {
      label: "Dashboard",
      to: "/professional/dashboard",
      icon: LayoutDashboard,
    },
    {
      label: "Profile",
      to: "/professional/profile",
      icon: UserCircle2,
    },
    {
      label: "Assignments",
      to: "/professional/assignments",
      icon: BriefcaseMedical,
    },
    {
      label: "Saved Jobs",
      to: "/professional/saved-jobs",
      icon: Heart,
    },
    {
      label: "Applications",
      to: "/professional/applications",
      icon: FileText,
    },
    {
      label: "Documents",
      to: "/professional/documents",
      icon: FolderOpen,
    },
    {
      label: "Timesheets",
      to: "/professional/timesheets",
      icon: Clock3,
    },
    {
      label: "Messages",
      to: "/professional/messages",
      icon: Mail,
    },
    {
      label: "Settings",
      to: "/professional/settings",
      icon: Settings,
    },
  ];

  const firstName =
    user?.firstName ||
    user?.first_name ||
    "";

  const lastName =
    user?.lastName ||
    user?.last_name ||
    "";

  const displayName =
    `${firstName} ${lastName}`
      .trim() ||
    "Professional";

  const initials =
    `${firstName?.[0] || "P"}${
      lastName?.[0] || ""
    }`.toUpperCase();

  return (
    <div className="pro-layout">
      <aside
        className={`pro-layout-sidebar ${
          sidebarOpen
            ? "open"
            : ""
        }`}
      >
        {/* BRAND */}
        <div className="pro-layout-sidebar-header">
          <button
            type="button"
            className="pro-layout-brand"
            onClick={() =>
              navigate(
                "/professional/dashboard"
              )
            }
          >
            <span className="pro-layout-brand-icon">
              <ShieldCheck
                size={22}
              />
            </span>

            <span className="pro-layout-brand-text">
              <strong>
                Zeth Health
              </strong>

              <small>
                Professional Portal
              </small>
            </span>
          </button>

          <button
            type="button"
            className="pro-layout-sidebar-close"
            onClick={
              closeSidebar
            }
            aria-label="Close navigation"
          >
            <X size={21} />
          </button>
        </div>

        {/* NAVIGATION */}
        <nav className="pro-layout-nav">
          {navItems.map(
            ({
              label,
              to,
              icon: Icon,
            }) => (
              <NavLink
                key={label}
                to={to}
                onClick={
                  closeSidebar
                }
                className={({
                  isActive,
                }) =>
                  `pro-layout-nav-link ${
                    isActive
                      ? "active"
                      : ""
                  }`
                }
              >
                <Icon
                  size={18}
                />

                <span>
                  {label}
                </span>
              </NavLink>
            )
          )}
        </nav>

        {/* BOTTOM */}
        <div className="pro-layout-sidebar-bottom">
          <button
            type="button"
            className="pro-layout-home"
            onClick={() =>
              navigate("/")
            }
          >
            <Home size={17} />

            Home
          </button>

          <div className="pro-layout-user">
            <div className="pro-layout-avatar">
              {initials}
            </div>

            <div className="pro-layout-user-copy">
              <strong>
                {displayName}
              </strong>

              <span>
                {user?.email ||
                  ""}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="pro-layout-logout"
            onClick={
              handleLogout
            }
          >
            <LogOut
              size={17}
            />

            Log Out
          </button>
        </div>
      </aside>

      {sidebarOpen && (
        <button
          type="button"
          className="pro-layout-overlay"
          onClick={
            closeSidebar
          }
          aria-label="Close navigation"
        />
      )}

      <div className="pro-layout-main">
        <header className="pro-layout-mobile-header">
          <button
            type="button"
            onClick={() =>
              setSidebarOpen(
                true
              )
            }
            aria-label="Open navigation"
          >
            <Menu size={22} />
          </button>

          <div>
            <strong>
              Zeth Health
            </strong>

            <small>
              Professional Portal
            </small>
          </div>
        </header>

        <div className="pro-layout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default ProfessionalLayout;